<template>
  <div class="container">
    <div class="headerImg">
      <span class="btn_left_time"> {{ nowTime }}</span>
     <span class="btn_right_time"><img src="@/assets/images/headerimg.png" @click="dialogVisible = true"  class="peoimg" alt=""></span>
      <img src="@/assets/images/quanping.png"  class="quanping" v-if="fullscreen==false" @click="screen" alt="">
		  <img src="@/assets/images/quanpingtui.png"  class="quanping"  @click="screen" alt="" v-else>
      <img src="@/assets/images/upimg.png"  class="upimg"  alt="" v-if="dialogVisible==true">
         <hefentianqi class="hefentianqi" />
         <!-- 退出登录弹窗 -->
        <div class="login logintc">
            <el-dialog
            title=""
            :visible.sync="dialogVisible"
            :modal="false"
            width="10%"
            >
              <span class="infornameclas">您好，欢迎访问！</span>
              <el-button type="primary" @click="handleClosetuichu" class="logintc_tc">
                  退出登录
              </el-button>
            </el-dialog>
        </div>
    </div>
  </div>
</template>
 
<script>
import hefentianqi from '@/views/weather/weather.vue';
export default {
  name: 'MyComponent',
  components: {
    hefentianqi,
  },
  data () {
    return {
        nowTime: '',
        fullscreen: false, //全屏
        dialogVisible: false,
    }
  },
  created(){
  },
   mounted() {
    this.getNowTime();
  },
  methods:{
     // 实时时间
    getNowTime() {
      let speed = 1000
      let that = this
      let theNowTime = function () {
        that.nowTime = that.timeNumber()
      }
      setInterval(theNowTime, speed)
    },
    timeNumber() {
      let today = new Date()
      let date = today.getFullYear() + '年' + this.twoDigits(today.getMonth() + 1) + '月' + this.twoDigits(today.getDate()) + '日'
      let time = this.twoDigits(today.getHours()) + ':' + this.twoDigits(today.getMinutes()) + ':' + this.twoDigits(today.getSeconds())
      let wk = new Date().getDay()
      let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      let week = weeks[wk]
      return date + '  ' + week + '  ' + time
    },
    twoDigits(val) {
      if (val < 10) return '0' + val
      return val
    },
     // 全屏
    isFullScreen(){
      if(!this.player || !this.play) return;
      this.player.fullScreen();
    },
    // 弹窗退出登录
	handleClosetuichu(done) {
		this.dialogVisible = false
        window.sessionStorage.clear();
    window.location.href = 'http://ep.ilhzn.cn/#/login';
    },
	screen() {
		let element = document.documentElement;
		if (this.fullscreen) {
			if (document.exitFullscreen) {
			document.exitFullscreen();
			} else if (document.webkitCancelFullScreen) {
			document.webkitCancelFullScreen();
			} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
			} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
			}
		} else {
			if (element.requestFullscreen) {
			element.requestFullscreen();
			} else if (element.webkitRequestFullScreen) {
			element.webkitRequestFullScreen();
			} else if (element.mozRequestFullScreen) {
			element.mozRequestFullScreen();
			} else if (element.msRequestFullscreen) {
			// IE11
			element.msRequestFullscreen();
			}
		}
		this.fullscreen = !this.fullscreen;
	},
  }
}
</script>

<style  scoped>
@import "@/assets/css/index.css";
@import "@/assets/css/left.css";
</style>